export const LANGUAGES = {
  af: 'af',
  am: 'am',
  ar: 'ar',
  be: 'be',
  bg: 'bg',
  bs: 'bs',
  ca: 'ca',
  cs: 'cs',
  da: 'da',
  de: 'de',
  el: 'el',
  en: 'en_us',
  en_ca: 'en_ca',
  en_gb: 'en_gb',
  en_us: 'en_us',
  es: 'es',
  es_es: 'es_es',
  et: 'et',
  fi: 'fi',
  fil: 'fil',
  fr: 'fr',
  fr_ca: 'fr_ca',
  he: 'he',
  hi: 'hi',
  hr: 'hr',
  hu: 'hu',
  id: 'id',
  is: 'is',
  it: 'it',
  ja: 'ja',
  ka: 'ka',
  kk: 'kk',
  kn: 'kn',
  ko: 'ko',
  ky: 'ky',
  lt: 'lt',
  lv: 'lv',
  ms: 'ms',
  nl: 'nl',
  no: 'no',
  pa: 'pa',
  pl: 'pl',
  pt: 'pt',
  pt_br: 'pt_br',
  ro: 'ro',
  ru: 'ru',
  sk: 'sk',
  sl: 'sl',
  sq: 'sq',
  sr: 'sr',
  sv: 'sv',
  sw: 'sw',
  te: 'te',
  th: 'th',
  tr: 'tr',
  tw: 'zh_tw',
  uk: 'uk',
  ur: 'ur',
  uz: 'uz',
  vi: 'vi',
  zh: 'zh_cn',
  zh_cn: 'zh_cn',
  zh_tw: 'zh_tw',
};
